import { FlowExtension } from '@magic-ext/flow';
import { MagicClientBase } from '../../MagicClientBase.js';

class FlowMagicClient extends MagicClientBase {
    constructor(props) {
        var _a;
        super({ apiKey: props.apiKey });
        this.network = (_a = props.network) !== null && _a !== void 0 ? _a : 'mainnet';
        this.rpcUrl = `https://rest-${this.network}.onflow.org`;
    }
    getClientConfig() {
        const config = {
            extensions: [
                new FlowExtension({
                    network: this.network,
                    rpcUrl: this.rpcUrl,
                }),
            ],
        };
        if (this.extensions.length > 0 && config.extensions) {
            config.extensions.push(...this.extensions);
        }
        return config;
    }
}

export { FlowMagicClient };
